export default __webpack_public_path__ + "static/media/Physics.11838194.pdf";